// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mini-voucher .mini-voucher {
  position: relative;
  padding: 0;
}
mini-voucher .mini-voucher .mini-voucher-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  color: white;
  background: linear-gradient(to top, black, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0));
  padding: 10px;
  padding-top: 20px;
  text-align: left;
}
mini-voucher .mini-voucher .mini-voucher-overlay h3 {
  margin-bottom: 5px;
  margin-left: 0;
}
mini-voucher .mini-voucher .mini-voucher-overlay p {
  white-space: nowrap;
  overflow: hidden;
  margin: 0;
  text-overflow: ellipsis;
}
mini-voucher .mini-voucher .mini-voucher-overlay a {
  color: var(--motes-gold);
}
mini-voucher .mini-voucher light-image.clickable > .image-container {
  cursor: pointer;
}
mini-voucher .mini-voucher .card-expansion {
  max-height: 0px;
  transition: 0.5s max-height;
  padding: var(--small-spacing);
}
mini-voucher .mini-voucher .card-expansion .product-title {
  font-weight: bold;
  font-size: initial;
  line-height: initial;
  padding: var(--motes-padding) 0;
  margin: 0;
}
mini-voucher .mini-voucher .card-expansion ul {
  margin-top: 0;
  margin-bottom: var(--motes-padding);
}
mini-voucher .mini-voucher .card-expansion ul.no-bullets {
  padding: 0;
}
mini-voucher .mini-voucher .card-expansion.show {
  max-height: 700px;
  transition: 0.5s max-height;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/mini-voucher/mini-voucher.component.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;EACA,UAAA;AAAR;AAEQ;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,oGAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;AAAZ;AAEY;EACI,kBAAA;EACA,cAAA;AAAhB;AAGY;EACI,mBAAA;EACA,gBAAA;EACA,SAAA;EACA,uBAAA;AADhB;AAIY;EACI,wBAAA;AAFhB;AAMQ;EACI,eAAA;AAJZ;AAOQ;EACI,eAAA;EACA,2BAAA;EACA,6BAAA;AALZ;AAOY;EACI,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,+BAAA;EACA,SAAA;AALhB;AAQY;EACI,aAAA;EACA,mCAAA;AANhB;AAQgB;EACI,UAAA;AANpB;AAWQ;EACI,iBAAA;EACA,2BAAA;AATZ","sourcesContent":["mini-voucher {\n    .mini-voucher {\n        position: relative;\n        padding: 0;\n\n        .mini-voucher-overlay {\n            position: absolute;\n            bottom: 0;\n            left: 0;\n            right: 0;\n            color: white;\n            background: linear-gradient(to top, black, rgba(0,0,0,.8), rgba(0,0,0,.8), rgba(0,0,0,0));\n            padding: 10px;\n            padding-top: 20px;\n            text-align: left;\n\n            h3 {\n                margin-bottom: 5px;\n                margin-left: 0;\n            }\n\n            p {\n                white-space: nowrap;\n                overflow: hidden;\n                margin: 0;\n                text-overflow: ellipsis;\n            }\n\n            a {\n                color: var(--motes-gold);\n            }\n        }\n\n        light-image.clickable > .image-container {\n            cursor: pointer;\n        }\n\n        .card-expansion {\n            max-height: 0px;\n            transition: 0.5s max-height;\n            padding: var(--small-spacing);\n            \n            .product-title {\n                font-weight: bold;\n                font-size: initial;\n                line-height: initial;\n                padding: var(--motes-padding) 0;\n                margin: 0;\n            }\n\n            ul {\n                margin-top: 0;\n                margin-bottom: var(--motes-padding);\n\n                &.no-bullets {\n                    padding: 0;\n                }\n            }\n        }\n        \n        .card-expansion.show {\n            max-height: 700px;\n            transition: 0.5s max-height;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
